import React, { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Radio, Select } from "antd";
import { deadlinesPayment } from "../../../constants/scadenze";
import { VaporDatePicker } from "../../vapor";
import moment from "moment";
import { DATETIME_FORMATZ_FOR_API } from "../../../constants/constants";

const Option = Select.Option;
const Payment = ({isReconciliationForm, isSave, requestBody, setRequestBody}) => {

  useEffect(() => {
    setRequestBody({
      ...requestBody,
      type: ["rent", "financing", "recurring_fees"].includes(requestBody.scope) ? "" : requestBody.type,
      payment: {
        ...requestBody.payment,        
        type: ["rent", "financing", "recurring_fees"].includes(requestBody.scope) && ((requestBody.payment.status === "due" && requestBody.payment.type !== "item_collect") || (requestBody.payment.status === "paid" && requestBody.payment.type !== "item_collect")) ? 
          "item_pays" : 
          ["rent", "financing", "recurring_fees"].includes(requestBody.scope) && ((requestBody.payment.status === "due" && requestBody.payment.type === "item_collect") || (requestBody.payment.status === "paid" && requestBody.payment.type === "item_collect")) ? 
            "item_collect" : requestBody.payment.type   
      }
    });
  }, [requestBody.scope]);
  
  useEffect(() => {    
    if (!isSave) return;
    // if (!document.querySelector(".errorOccurs")) return;
    // faccio scrollare al primo elemento in errore
    document.querySelector(".errorOccurs")?.scrollIntoView();
  }, [isSave]);
  
  const scopes = [];
  const intl = useIntl();
  for (const [key] of Object.entries(deadlinesPayment)) { 
    
    if (key !== "PMXA") {
      if (requestBody.scope === "fiscal_social_security" && ["PM01", "PM04", "PM08", "PM23", "PMXC"].indexOf(key) > -1) {
        scopes.push(<Option value={key} key={key}>
          {<FormattedMessage id={deadlinesPayment[key]} />}
        </Option>);
      } else if (requestBody.scope !== "fiscal_social_security" && key !== "PMXC") {
        scopes.push(<Option value={key} key={key}>
          {<FormattedMessage id={deadlinesPayment[key]} />}
        </Option>);
      }
    }
  }
  return requestBody.status.confirmed && (
    <div style={{marginTop: "48px"}}>
      {!isReconciliationForm &&
      <div className="add-deadline-section">
        <FormattedMessage id="deadlines.pages.create.payment" />
      </div>
      }

      {
        requestBody.payment.type !== "item_collect" && (
          requestBody.scope === "fiscal_social_security" || 
            requestBody.scope === "studio_reminder"
        ) && 
        <div className={isSave && (!["rent", "credit", "debt", "financing", "recurring_fees"].includes(requestBody.scope) &&  !requestBody.payment.type) ? "errorOccurs" : ""}>
          <div className="labelDialogContent">
              Chi si occupa del pagamento? *
          </div>
          <Radio.Group
            onChange={e => setRequestBody({
              ...requestBody,
              payment: {
                ...requestBody.payment,
                type: e.target.value
              }
            })}
            value={requestBody.payment.type}            
          >
            <Radio value={"item_pays"}>Cliente</Radio>
            <Radio value={"manager_pays"}>Studio</Radio>
            <Radio value={"manager_charge"}>Studio sul c/c Cliente</Radio>
          </Radio.Group>
        </div>        
      }   
      <div className={isReconciliationForm ? "" : "doubleCols"}>
        <div
          className="customSelect"
          style={{
            marginRight: "38px"
          }}
        >
          <div className={isSave && !requestBody.payment?.mode?.id ? "errorOccurs" : ""}>
            <div className="labelDialogContent">
              {<FormattedMessage id={"deadlines.pages.table.paymentTypeMinus"} />}{" "}
            *
            </div>
            <Select
              dropdownClassName="modalOverlay"
              getPopupContainer={trigger => trigger.parentNode}
              placeholder="Scegli una modalità di pagamento"
              size="large"
              style={{ width: "100%" }}
              value={
                requestBody.payment.mode.id
                  ? intl.formatMessage({id: deadlinesPayment[requestBody.payment.mode.id]})
                  : undefined
              }
              onChange={(value) => {
                setRequestBody({
                  ...requestBody,
                  payment:
                    requestBody.payment.status === "paid"
                      ? {
                        ...requestBody.payment,
                        execution: {
                          ...requestBody.payment.execution,
                          mode: value
                        },
                        mode: { id: value }
                      }
                      : {
                        ...requestBody.payment,
                        mode: { id: value }
                      }
                });
              }}
            >
              {scopes}
            </Select>
          </div>
        </div>
        <div style={{
          marginRight: "38px"
        }}>
          {
            requestBody.payment.status === "paid" && 
                (<>
                  <div className="labelDialogContent">
                    {<FormattedMessage id={
                      requestBody.payment.type === "item_collect" 
                        ? "deadlines.pages.table.paymentPlusDate"
                        : "deadlines.pages.table.paymentMinusDate"} />}{" "}
              *
                  </div>
                  <div className="customPicker">
                    <VaporDatePicker
                      getPopupContainer={(trigger) => trigger.parentNode}
                      dropdownClassName="modalOverlay"
                      onChange={date => {
                        setRequestBody({
                          ...requestBody,
                          payment: {
                            ...requestBody.payment,
                            execution: {
                              ...requestBody.payment.execution,
                              date: moment(`${date}`).format(DATETIME_FORMATZ_FOR_API)
                            }
                          }
                        });                        
                      }}
                      placeholder={"gg/mm/aaaa"}
                      style={{ width: "100%" }}
                    />
                  </div>
                </>
                )
          }
        </div>
      </div>
    </div>   
    
  );
};

export default Payment;